import { createSelector } from '@ngrx/store';

import * as fromRouter from '@ngrx/router-store';
import * as fromRoot from '../reducers'

export const selectRoutingPageTitle = createSelector(fromRoot.selectRouterState,
  (state: fromRouter.RouterReducerState<fromRoot.RouterStateUrl>) => state && state.state && state.state.pageTitle
);

export const selectCurrentQueryParams = createSelector(fromRoot.selectRouterState,
  (state: fromRouter.RouterReducerState<fromRoot.RouterStateUrl>) => state && state.state && state.state.queryParams
);




// WEBPACK FOOTER //
// ./src/app/core/store/selectors/router.selectors.ts